import {Injectable} from '@angular/core';
import {UserModel} from '../models/User';
import {firstValueFrom} from 'rxjs/internal/firstValueFrom';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';

const USER_URL = '/api/user';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(private http: HttpClient) {
    }

    async getPremiumUserCount(plan: string): Promise<number> {
        const response = await firstValueFrom(this.http.get<{ count: number }>(`${USER_URL}/count/${plan}`));
        return response.count;
    }

    update(user: Partial<UserModel>): Observable<Partial<UserModel>> {
        return this.http.put<Partial<UserModel>>(`${USER_URL}/me`, user, { withCredentials: true });
    }

    async getTotalUserCount(): Promise<number> {
        const response = await firstValueFrom(this.http.get<{count: number}>(`${USER_URL}/count/total`))
        return response.count;
    }
    public updateCartId(cartId: string): Observable<any> {
        return this.http.post<any>(`${USER_URL}/update-cart-id`, {cartId}, {withCredentials: true})
    }

    public setReferral(eventType: string): Observable<any> {
        return this.http.post<any>(`${USER_URL}/set-referral`, {eventType}, {withCredentials: true})
    }

    public updateNotificationStatus(type: 'email' | 'sms', enabled: boolean) {
        return this.http.post<any>(`${USER_URL}/notifications`, {type, enabled}, {withCredentials: true})
    }

    public updateACTag(tagId: number): Observable<void> {
        return this.http.post<any>(`${USER_URL}/ac/tags/${tagId}/add`, {}, {withCredentials: true})
    }

    public getUserACTags(): Observable<{ tags: Number[] }>  {
        return this.http.get<any>(`${USER_URL}/ac/tags`, {withCredentials: true})
    }


}
